import * as React from 'react';
import { cn } from 'lib/utils';

const Input = React.forwardRef(({ className, type, ...props }, ref) => {
  return (
    <input
      type={type}
      className={cn(
        'flex h-10 w-full rounded-md border-0 bg-muted px-3 py-2 text-sm text-foreground shadow-none outline-none transition-colors',
        'placeholder:text-muted-foreground',
        'focus:outline-none focus-visible:outline-none focus-visible:bg-accent focus-visible:ring-0 focus-visible:ring-offset-0',
        'disabled:cursor-not-allowed disabled:opacity-50',
        'file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground',
        className
      )}
      ref={ref}
      {...props}
    />
  );
});
Input.displayName = 'Input';

export { Input };
